import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import ChiamaWeb, {CChiamaWebParametri} from "src/ChiamaWeb";
import * as Dati from "src/Dati";
import * as DatiFide from "../../../DatiFide";
import * as Glob from "../../../Globale";
import { Trad } from "../../../components/";
import { _LimitChart, _PieChart } from "../../components";
import { IRouteParam } from "../../pages/ExposureLimit";

interface IExposureLimitChartsProps {
    ID_FideAffidamento: number;
    ID_TipoFideAffidamento: string;
}

export const _ExposureLimitCharts: React.FC<IExposureLimitChartsProps> = ({ ID_FideAffidamento, ID_TipoFideAffidamento }) => {
    const [ParentCompanyLimits, setParentCompanyLimits] = useState<Dati.Dictionary<number> | null>(null);
    const [Limits, setLimits] = useState<DatiFide.CDatiFideAffidamentoLimite>(new DatiFide.CDatiFideAffidamentoLimite());

    const ID_Anag = useParams<IRouteParam>().ID_Anag || "0";

    useEffect(() => {
        const Param: CChiamaWebParametri = {
            URL: `/api/fideaffidamento/GetLimitiCapogruppo?ID_FideAffidamento=${ID_FideAffidamento}&ID_Anag=${ID_Anag}`,
            OnRis: (sender: ChiamaWeb, data: DatiFide.CRisAPIListaLimitiFideAffidamentoCapogruppo) => {
                if (data.Dati.length) {
                    const chartData: Dati.Dictionary<number> = {};
                    let remainedLimit: number = 0;

                    data.Dati.forEach((item: DatiFide.CDatiFideAffidamentoLimiteCapogruppo) => {
                        const label = Trad.TradParam("{1-S}: Affidamento utilizzato {2-I}", [`${item.ID_FideAffidamento} ${item.Denominazione}`, item.LimiteMassimoContraenteUtilizzato]);

                        chartData[label] = item.LimiteMassimoContraenteUtilizzato;
                        remainedLimit += item.LimiteMassimoContraente - item.LimiteMassimoContraenteUtilizzato;
                    });
                    chartData[Trad.TradParam("Affidamenti non utilizzati {1-I}", [remainedLimit])] = remainedLimit;

                    setParentCompanyLimits(chartData);
                }
            }
        };
        new ChiamaWeb().Chiama(Param);
    }, [ID_FideAffidamento, useParams<IRouteParam>().ID_Anag]);

    useEffect(() => {
        const Param: CChiamaWebParametri = {
            URL: `/api/fideaffidamento/GetLimiti?ID_FideAffidamento=${ID_FideAffidamento}`,
            OnRis: (sender: ChiamaWeb, data: DatiFide.CRisAPIListaLimitiFideAffidamento) => {
                if (data.Dato) {
                    setLimits(data.Dato);
                }
            }
        };
        new ChiamaWeb().Chiama(Param);
    }, [ID_FideAffidamento]);

    return (
        <>
            {ParentCompanyLimits && (
                <Grid item xs={12} md={6}>
                    <_PieChart Title="Affidamenti gruppo" Data={ParentCompanyLimits} TranslationsOff />
                </Grid>
            )}
            {ID_TipoFideAffidamento == Glob.Tipi_FA_Affidamento ? (
                <>
                    <Grid item xs={12} md={3}>
                        <_LimitChart
                            Title="FA-Provvisorie"
                            UsedVal={Limits.LimiteMassimoContraenteUtilizzato_Provvisorie}
                            LeftVal={Limits.LimiteMassimoContraente_Provvisorie - Limits.LimiteMassimoContraenteUtilizzato_Provvisorie}
                            UsedLabel="Limite utilizzato"
                            LeftLabel="Limite rimasto"
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <_LimitChart
                            Title="FA-NonProvvisorie"
                            UsedVal={Limits.LimiteMassimoContraenteUtilizzato_NonProvvisorie}
                            LeftVal={Limits.LimiteMassimoContraente_NonProvvisorie - Limits.LimiteMassimoContraenteUtilizzato_NonProvvisorie}
                            UsedLabel="Limite utilizzato"
                            LeftLabel="Limite rimasto"
                        />
                    </Grid>
                </>
            ) : (
                <Grid item xs={12} md={6}>
                    <_LimitChart
                        Title="Utilizzo affidamento"
                        UsedVal={Limits.LimiteMassimoContraenteUtilizzato}
                        LeftVal={Limits.LimiteMassimoContraente - Limits.LimiteMassimoContraenteUtilizzato}
                        UsedLabel="Limite utilizzato"
                        LeftLabel="Limite rimasto"
                    />
                </Grid>
            )}
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/ExposureLimit/ExposureLimitCharts.tsx